import React from "react";
import { useTranslation } from "react-i18next";
import Dropdown from "../../../../components/Dropdown";
import { INVOICE_STATUS, VALIDATION_FIELD_MAPPING } from "../../../../utils/appConstant";
import { Add } from "../../../../interfaces/invoice.interface";
import { Validation } from "../../../../interfaces/common";
import { getYearLookupData, getInvoiceWarningDateString } from "../../../../utils/methods";
import Link from "../../../../components/Link";
import { Modules, RouteParamsTypes } from "../../../../enums";

interface AddModalContentProps {
  formData: Add;
  validation: Validation;
  dropdownSearchData: any;
  allProperties: any[];
  properties: any[];
  allMonths: any[];
  months: any[];
  invoiceError: any;
  onDropdownSearchChange: (e: any, name: string) => void;
  onInputBlur: (e: any, name: string) => void;
  onInputChange: (e: any, name: string) => void;
}

const AddModalContent: React.FC<AddModalContentProps> = ({
  formData,
  validation,
  allProperties,
  properties,
  allMonths,
  months,
  dropdownSearchData,
  invoiceError,
  onDropdownSearchChange,
  onInputBlur,
  onInputChange
}) => {
  const { t } = useTranslation();

  const handleEditClick = (id: string) => {
    window.open(`${Modules.invoices}${RouteParamsTypes.edit}/${id}`, '_blank')
  };

  const handleViewClick = (id: string) => {
    window.open(`${Modules.invoices}${RouteParamsTypes.view}/${id}`, '_blank')
  };

  return (
    <form className="card-body">
      <div className="d-flex align-items-center p-3 mb-4 rounded border border-warning">
        <i className="ri-alert-line fs-3 me-3 text-warning"></i>
        <span className="text-body">
          {t("invoices.addList.pageTexts.modal.reservationWarning1")}<strong>{getInvoiceWarningDateString()}</strong>{t("invoices.addList.pageTexts.modal.reservationWarning2")}
        </span>
      </div>
      <div className="row g-6 mb-4">
        <div className="col-md-12">
          <div className="form-floating form-floating-outline">
            <Dropdown
              values={formData.property ? [formData.property] : []}
              required
              options={(properties || []).map((property) => ({
                label: property.name,
                value: property.id
              }))}
              allOptions={(allProperties || []).map((property) => ({
                label: property.name,
                value: property.id
              }))}
              id={VALIDATION_FIELD_MAPPING.property}
              name={VALIDATION_FIELD_MAPPING.property}
              searchText={dropdownSearchData.property}
              onSearch={onDropdownSearchChange}
              placeholder={t('invoices.addList.pageTexts.form.property.placeholder')}
              label={t('invoices.addList.pageTexts.form.property.label')}
              error={!!validation.fields.find((field) => field.field === VALIDATION_FIELD_MAPPING.property)}
              errorMessage={validation.fields.find((field) => field.field === VALIDATION_FIELD_MAPPING.property)?.message ?? ''}
              onChange={onInputChange}
              onBlur={onInputBlur}
            />
          </div>
        </div>
      </div>

      <div className="row g-6">
        <div className="col-md-6">
          <div className="form-floating form-floating-outline">
            <Dropdown
              values={formData.month ? [formData.month] : []}
              required
              options={(months || []).map((month) => ({
                label: month.name,
                value: month.id
              }))}
              allOptions={(allMonths || []).map((month) => ({
                label: month.name,
                value: month.id
              }))}
              id={VALIDATION_FIELD_MAPPING.month}
              name={VALIDATION_FIELD_MAPPING.month}
              searchText={dropdownSearchData.month}
              onSearch={onDropdownSearchChange}
              placeholder={t('invoices.addList.pageTexts.form.month.placeholder')}
              label={t('invoices.addList.pageTexts.form.month.label')}
              error={!!validation.fields.find((field) => field.field === VALIDATION_FIELD_MAPPING.month)}
              errorMessage={validation.fields.find((field) => field.field === VALIDATION_FIELD_MAPPING.month)?.message ?? ''}
              onChange={onInputChange}
              onBlur={onInputBlur}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-floating form-floating-outline">
            <Dropdown
              values={formData.year ? [formData.year] : []}
              required
              options={(getYearLookupData().filter(item => item.name.toLowerCase().includes(dropdownSearchData.year)) || []).map((year) => ({
                label: year.name,
                value: year.id
              }))}
              allOptions={(getYearLookupData() || []).map((year) => ({
                label: year.name,
                value: year.id
              }))}
              id={VALIDATION_FIELD_MAPPING.year}
              name={VALIDATION_FIELD_MAPPING.year}
              searchText={dropdownSearchData.year}
              onSearch={onDropdownSearchChange}
              placeholder={t('invoices.addList.pageTexts.form.year.placeholder')}
              label={t('invoices.addList.pageTexts.form.year.label')}
              error={!!validation.fields.find((field) => field.field === VALIDATION_FIELD_MAPPING.year)}
              errorMessage={validation.fields.find((field) => field.field === VALIDATION_FIELD_MAPPING.year)?.message ?? ''}
              onChange={onInputChange}
              onBlur={onInputBlur}
            />
          </div>
        </div>
      </div>

      {
        invoiceError && <div className="row">
          <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback d-block">
            <p className="mb-0 mt-2">
             {t("invoices.addList.pageTexts.modal.invoiceError1")}
              <span
                className="span mb-1 text-decoration-underline hyperlink"
                onClick={() => invoiceError.invoice_status !== INVOICE_STATUS.completed ? handleEditClick(invoiceError?.invoice_id) : handleViewClick(invoiceError?.invoice_id)}
              >
                {invoiceError.invoice_name}
              </span>
              {t("invoices.addList.pageTexts.modal.invoiceError2")}
            </p>
          </div>
        </div>
      }
    </form>
  );
}

export default AddModalContent;